import {
  makeResponsive,
  placeTitle,
  placeImage,
  placeInput,
  placeSlider,
  hoverMe,
  placeRec,
  hiddenPt,
  fixedPt,
  clearInputFields,
  dragMe,
  placeArrow,
  placeGravity,
  placeText,
  placeMiddleText,
  placeLine,
  placePoint,
  placeGlider,
  placeRuler,
  placeLeftText,
  placeCircle,
  placeAngle,
  placeDash,
  placeLabel,
  placeRightText,
//placePoint(board, positionX, positionY, size, cols1, cols2)
//placeDash(board, Pt1, Pt2, width, cols)
  placeArc,
  placeLogo,
  placeErase,
  placeShuffle,
  placeTest,
  placeSeg,
  setConfig,
  placeStat,
  drawTriangle,
  shuffle,
  placeEraseLeft,
  placeTapeHori,
  placeTapeVert,
  placeSq,
  placeBoldText,
  placeRedo,
  placeUndo,
  drawPoint,
  drawTri,
  setSize,
  labelIt,
  drawDash,
  placeEggs,
  drawLine,
  setWidth,
  drawIntersection,
  drawPerpP,
  drawAngle,
  createSpace,
  createAxes,
  writeHTMLText
} from '../Utils';
const Boxes = {
    //JXG.Options.line.highlight=false;
    box1: function () {
    //Create the Board
    var graph =createSpace(-7,7,-5,9);
    //graph.suspendUpdate();
    createAxes(graph);
    // Layering
    graph.options.axis.strokeWidth=0;
    graph.options.layer['image']=17;
    graph.options.layer['text']=19;
    graph.options.layer['line']=16;
    graph.options.layer['point']=17;
    graph.options.layer['glider']=17;
    graph.options.layer['angle']=18;
    graph.options.board.minimizeReflow = 'none';
    graph.options.point.showInfobox =false;
    graph.options.line.highlight=false;
    graph.options.image.highlight=false;
    graph.options.text.highlight=false;
    graph.options.curve.highlight=false;
    //Make the board responsive
    makeResponsive(graph);
    // Create Logo
    placeLogo(graph);
    //Create Title
    placeTitle(graph, 'Solving Quadratic Equations', '');
///////////////////////////////////////////////////////////////////////////////
   // Equation
   var eqn = writeHTMLText(graph, -6, 6.5, 'Equation: ax^2 + bx + c = 0');
   eqn.setAttribute({anchorX:'left'});
    //Discriminant
    var a1txt = graph.create('text',[-6, 5.5, 'a = '],{cssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(18*graph.canvasWidth/500.)},fixed:true});
//
    var b1txt = graph.create('text',[-6, 4.5, 'b = '],{cssStyle:'fontFamily:Oswald', fontSize:function(){return Math.round(18*graph.canvasWidth/500.)}, fixed:true});
//
    var c1txt = graph.create('text',[-6, 3.5, 'c = ' ],{cssStyle:'fontFamily:Oswald', fontSize:function(){return Math.round(18*graph.canvasWidth/500.)},fixed:true});
    //inputs
    var aValue = graph.create('input', [-5.0, 5.5, -1.0, ''], {cssStyle: 'width:7.5%;background-color:#008CBA;border-radius: 3.5px;', fontSize:function(){return Math.round(18*graph.canvasWidth/500.)}, fixed:true});
    //
    var bValue = graph.create('input', [-5.0, 4.5, 1.0,  ''], {cssStyle: 'width:7.5%;background-color:#008CBA;border-radius: 3.5px;', fontSize:function(){return Math.round(18*graph.canvasWidth/500.)},fixed:true});
    //
    var cValue = graph.create('input', [-5.0, 3.5, 1.0,  ''], {cssStyle: 'width:7.5%;background-color:#008CBA;border-radius:3.5px;', fontSize:function(){return Math.round(18*graph.canvasWidth/500.)},fixed:true});
//
    var disc = placeLeftText(graph, 1, 6.5, function(){return 'Discriminant D = ' + (bValue.Value()*bValue.Value()-4*aValue.Value()*cValue.Value()).toFixed(2);});
    //Solutions
    var twoSol = placeLeftText(graph, 1, 5.5, 'There are TWO real solutions.');
    twoSol.setAttribute({visible:()=>bValue.Value()*bValue.Value()- 4*aValue.Value()*cValue.Value()>0});
    //
    var oneSol = placeLeftText(graph, 1, 5.5, 'There is ONE real solution.');
    oneSol.setAttribute({visible:()=>bValue.Value()*bValue.Value()- 4*aValue.Value()*cValue.Value()==0});

    var noSol = placeLeftText(graph, 1, 5.5, 'There are NO solutions.');
    noSol.setAttribute({visible:()=>bValue.Value()*bValue.Value()- 4*aValue.Value()*cValue.Value()<0});
    ///////////////////////////////////////////////////////
    var x1 = writeHTMLText(graph, 1.5, 4.5, function(){return 'x_1 = ' + ((-bValue.Value() + Math.sqrt(bValue.Value()*bValue.Value() - 4*aValue.Value()*cValue.Value()))/(2*aValue.Value())).toFixed(2);});
    x1.setAttribute({anchorX:'left',visible:()=>bValue.Value()*bValue.Value()- 4*aValue.Value()*cValue.Value()>=0})
    ///////////////////////////////////////////////////////////////
    var point1 = graph.create('point',[function(){return ((-bValue.Value() + Math.sqrt(bValue.Value()*bValue.Value() - 4*aValue.Value()*cValue.Value()))/(2*aValue.Value())).toFixed(2);},0],{name:'x1',size:4, face:'square', strokeColor:'black', fillColor:'yellow'});
    //x2sss
    var x2 = writeHTMLText(graph, 3.5, 4.5, function(){return 'x_2 = ' + ((-bValue.Value() - Math.sqrt(bValue.Value()*bValue.Value() - 4*aValue.Value()*cValue.Value()))/(2*aValue.Value())).toFixed(2);});
    x2.setAttribute({anchorX:'left',visible:()=>bValue.Value()*bValue.Value()- 4*aValue.Value()*cValue.Value()>=0})


    var point2 = graph.create('point',[function(){return ((-bValue.Value() - Math.sqrt(bValue.Value()*bValue.Value() - 4*aValue.Value()*cValue.Value()))/(2*aValue.Value())).toFixed(2);},0],{name:'x2',size:4, face:'square', strokeColor:'black', fillColor:'yellow', visible:()=>bValue.Value()*bValue.Value()-4*aValue.Value()*cValue.Value()>0});
    //
    var graph1 = graph.create('functiongraph', [function(x){return cValue.Value()*1+ aValue.Value()*x*x + bValue.Value()*x;}, -5, 4], {strokeColor:'red', strokeWidth:4});
    //
},
}
export default Boxes;
